import React, { useEffect, useState } from "react";
import { useRouter, useSearchParams } from "next/navigation";
import { isEmpty, get } from "lodash";
import { decodedToken, getCookie, getOrgId , setOrgId} from "../core/utils/auth-utils";
import { isAdminType, isCustomerType, isValidType, isVendorType } from "../core/utils/customer-type";
import { logger } from "../core";
import { LoginForm, OTPForm, LoginThemeWrapper, InactiveAccount } from "./components";

type LoginProps = {
  data?: any;
  isVendor?: boolean;
};

export default function Login({ data }: LoginProps) {
  const router = useRouter();
  const searchParams = useSearchParams();
  const [mounted, setMounted] = useState(false);
  const [showOTP, setShowOTP] = useState(false);
  const [userId, setUserId] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);
  const [isInactive, setIsInactive] = useState(false);
  const [accessTo, setAccessTo] = useState<string>();

  useEffect(() => {
    setMounted(true);
  }, []);

  useEffect(() => {
    logger.log({ accessTo: searchParams.get("access"), searchParams });
    const token = getCookie("token");
    if (!isEmpty(token) && token !== "null" && token != "undefined") {
      var userInfo: any = decodedToken(token);
      setAccessTo(searchParams.get("access"));
      processPath(userInfo.type, {});
    }
  }, []);

  const processPath = (type: string, data: any) => {
    let path = "";
    logger.log({ type, data });
    const acc = searchParams.get("access");
    logger.log({ acc });
    if (acc && isValidType(type)) {
      router.push(acc);
      return;
    }

    if (isCustomerType(type)) {
      logger.log({ type });
      path = "/customers";
    } else if (isVendorType(type)) {
      logger.log({ type });
      path = "/vendors";
    } else if (isAdminType(type)) {
      path = "/admin";
    } else {
      path = "/login";
    }

    if (!isEmpty(path)) {
      router.push(path + "?&t=" + new Date().getTime().toString());
    }
  };

  const handleLoginSuccess = (data: any) => {
    // Handle successful login
    const type = get(data, "body.response.type");
    const defaultOrgId = get(data, "body.response.userId");
    if (defaultOrgId) {
      setOrgId(defaultOrgId);
    }
    processPath(type, {});
   
   
  };

  const handleShowOTP = (userId: string) => {
    setUserId(userId);
    setShowOTP(true);
  };

  const handleOTPBack = () => {
    setShowOTP(false);
    setUserId("");
  };

  const handleOTPSuccess = (data: any) => {

    const type = get(data, "body.profile.type");
    const defaultOrgId = get(data, "body.profile.userId");
    if (defaultOrgId) {
      setOrgId(defaultOrgId);
    }
    processPath(type, {});
  };

  if (!mounted) return null;

  if (isInactive) {
    return <InactiveAccount />;
  }

  return (
    <LoginThemeWrapper>
      {!showOTP ? (
        <LoginForm
          onLoginSuccess={handleLoginSuccess}
          onShowOTP={handleShowOTP}
          loading={loading}
          setLoading={setLoading}
          accessTo={accessTo}
        />
      ) : (
        <OTPForm
          userId={userId}
          onBack={handleOTPBack}
          onSuccess={handleOTPSuccess}
          loading={loading}
          setLoading={setLoading}
        />
      )}
    </LoginThemeWrapper>
  );
}
